export default "__VITE_ASSET__97370525__"